// extracted by mini-css-extract-plugin
export default {"cls1":"WorkCard-cls1_TuA","cls2":"WorkCard-cls2_LH1 WorkCard-cls1_TuA"};